module.exports = __webpack_public_path__ + "img/casino2.3182bd2e.png";